/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddVisualization = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 22H2V2h6zm-4-2h2V4H4zm11 2H9V8h6zm-4-2h2V10h-2zm11 2h-6V12h6zm-4-2h2v-6h-2zm2-16h2v2h-2v2h-2V6h-2V4h2V2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAddVisualization as AddVisualization };
